<!--
 功能名称:千里眼平台(技师)-推销详情
 开发人:梁高权
 创建时间:2021/04/08
 最后修改时间:2021/04/08
-->
<template>
  <div class="sell-wrap">
    <timeScreen :active="active" v-on:timeChange="timeChange($event)"/>
    <synchronizeTime/>
   <div class="Detail" v-show="sellList.length>0">
      <div class="title line">
        <span v-for="(item,index) in titleList" :key="index">{{item}}</span>
      </div>
      <ul>
        <li v-for="(item,index) in sellList" :key="index">
        <!--  <div class="name" @click="item.show=!item.show">
            <span>{{item.group_name}}</span>
            <van-icon name="arrow-down" color="#666" />
          </div> -->
          <div class="line">
            <span>{{item.working_type}}</span>
            <span>{{item.service_num}}</span>
            <span>¥{{item.total_money}}</span>
    <!--        <span>{{item.ext_service_num}}</span>
            <span>¥{{item.ext_total_money}}</span> -->
          </div>
        </li>
      </ul>
     <div class="sumUp">
        <span>合计</span>
        <div>
          <span>{{sumUp.num}}</span>
          <span>¥{{sumUp.money}}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import table from '@/api/table'
export default {
  name: 'sell',
  components: {
    'timeScreen':() => import('./timeScreen'),
    'synchronizeTime':() => import('./synchronizeTime')
  },
  filters: {},
  mixins: [],
  props: {active:Number},
  data () {
    return {
      titleList:['项目名称','数量','提成'],
      sellList:[],
      sumUp:new Object()
    }
  },
  computed: {},
  watch: {},
  created () {

  },
  mounted () {

  },
  methods: {
    timeChange(val){
      if(this.active===1) this.sellDetail(val)
    },
    // 获取推销详情
    sellDetail(data){
      // console.log(data)
      table.sellDetail(data).then(res=>{
        let serviceNum=0,totalMoney=0;
        for(let i=0;i<res.data.list.length;i++){
          serviceNum+=res.data.list[i].service_num
          totalMoney+=res.data.list[i].total_money
        }
        this.sumUp={num:serviceNum,money:totalMoney}
        this.sellList=res.data.list

      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .sell-wrap {
    .Detail{
      margin: 22px auto 30px;
      padding: 1px 25px 1px;
      background:#fff;
      width: 690px;
      border-radius: 16px;
      // height: 1200px;
      .line{
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
          width: 200px;
          text-align: center;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      .title{
        color: #999;
        font-size: 24px;
        margin-top: 40px;
      }
      ul{
        border-bottom: 2px solid #EAEAEA;
        padding-bottom: 55px;
        margin-top: 37px;
        li{
          .name{
            color:#333;
            font-size: 28px;
            >span{
              margin-right: 10px;
            }
          }
          .line{
            line-height: 72px;
            color: #666666;
            font-size: 28px
          }
        }
        li:nth-of-type(odd){background: #F1F1F1;border-radius: 10px}
      }
      .sumUp{
        display: flex;
        justify-content: space-between;
        line-height: 90px;
        >span{
          color: #333;
          font-size: 28px;
          font-weight: bold;
        }
        >div{
          width: 420px;
          display: flex;
          justify-content: space-between;
          color: #691BFF;
          font-size: 28px;
          font-weight: bold;
          span{width: 200px;text-align:center;}
        }
      }
    }
  }
</style>
